import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import InvitePopup from 'component/WelcomeBackScreen/InvitePopup';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Arrow1 from 'assets/images/Arrow1.png';
import { ReactComponent as AddUser } from 'assets/svg/Add User.svg';

function InvitePage() {
  const history = useHistory();
  const [openInvite, setOpenInvite] = useState(true);

  return (
    <>
      <Box sx={styles.dashboardContainer}>
        <Box sx={styles.headerControlWrapper}>
          <Box sx={styles.backNavigationRow} onClick={() => history.goBack()}>
            <img alt="arrow" src={Arrow1} />
            <Typography variant="body2" sx={styles.backText}>
              Back to Previous
            </Typography>
          </Box>
        </Box>
        {/* --- TITLE --- */}
        <Box sx={styles.titleHeaderRow}>
          <AddUser />
          <Typography variant="h5" sx={styles.moduleTitle}>
            Invite People
          </Typography>
        </Box>

        <InvitePopup
          openInvite={openInvite}
          setOpenInvite={setOpenInvite}
          BrowsingPartner={false}
          fromleftmenu={true}
        />
      </Box>
    </>
  );
}
// --- MODULE STYLING MAP ---
const styles = {
  dashboardContainer: {
    p: '32px',
    backgroundColor: '#FAFAFA',
    minHeight: '100vh',
  },
  headerControlWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: '20px',
  },
  backNavigationRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    cursor: 'pointer',
    width: 'fit-content',
    '&:hover': { opacity: 0.8 },
  },
  backText: {
    color: '#6C2AD2',
    fontWeight: 400,
    fontSize: '16px',
    fontFamily: 'Poppins',
  },
  titleHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    mb: 3,
  },
  moduleTitle: {
    fontWeight: 600,
    color: '#111827',
    fontSize: '32px',
    fontFamily: 'Poppins',
  },
};
export default InvitePage;
